import "./BlockBadge.css";

function hexToRGBA(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function BlockBadge({ name, color, href }) {
    const style = { color: color, backgroundColor: hexToRGBA(color, 0.15), border: `1px solid ${color}` };

    if (href) {
        return (
            <a className="block-badge block-badge-link" style={style} href={href} target="_blank" rel="noopener noreferrer" title="Open this block in the bot editor">
                <i className="fas fa-cube"></i>
                {name}
            </a>
        );
    }

    return (
        <span className="block-badge" style={style}>
            <i className="fas fa-cube"></i>
            {name}
        </span>
    );
}

export default BlockBadge;
